import { ArrayWms } from "../../../assets/ts/ArrayWms.ts";
import * as GlobalService from "../global_services";

export const printZplFormatedLabel = function (zplFormatedResponse) {
    // The ship progress caller toasts once, and only when this resolves true.
    var printed = GlobalService.printDataInZplPrinter(zplFormatedResponse, false, {
        suppressSuccessNotification: true,
    });
    var eventItem = new CustomEvent("EventSmallParcelDataChanged", { detail: { "action": "update" } });
    document.dispatchEvent(eventItem);
    return printed;
};

export const printPdfFormatedLabel = function (pdfFormatedResponse, pdfFileName) {
    var blob = ArrayWms.convertBase64ToByteArray(pdfFormatedResponse, "application/pdf");
    // Use new smart printing wrapper that respects silent print settings
    GlobalService.printOrViewPdf(blob, "application/pdf", pdfFileName, false);

    var eventItem = new CustomEvent("EventSmallParcelDataChanged", { detail: { "action": "update" } });
    document.dispatchEvent(eventItem);
};

/**
 * Documents whose rendered format differs from the shipping label.
 * PDFs go to the full-page Documents printer (or a preview tab if none is selected).
 * ZPL goes to the label printer. Do not use printOrViewPdf — that forces 4x6.
 */
function shipDocumentPrintFailedMessage() {
    if (typeof window !== "undefined" && typeof window.translate === "function") {
        var translated = window.translate("Error_ShipDocument_PrintFailed");
        if (translated && translated !== "Error_ShipDocument_PrintFailed") {
            return translated;
        }
    }
    return "A shipping document failed to print.";
}

function notifyZplPrintFailure(err) {
    console.error("printShipDocuments ZPL failed", err);
    GlobalService.notification("error", shipDocumentPrintFailedMessage());
}

function sendZplBatch(zplContents) {
    if (!zplContents.length) {
        return;
    }
    var zplPayload = zplContents.length === 1 ? zplContents[0] : zplContents.slice();
    try {
        var printed = GlobalService.printDataInZplPrinter(zplPayload, false, {
            suppressSuccessNotification: true,
        });
        if (printed && typeof printed.then === "function") {
            printed.catch(notifyZplPrintFailure);
        }
    } catch (err) {
        notifyZplPrintFailure(err);
    }
}

export const printShipDocuments = function (documents) {
    if (!Array.isArray(documents) || documents.length === 0) {
        return;
    }

    // Consecutive ZPL stays one printer call, in list order. A PDF splits the run
    // so ZPL, PDF, ZPL prints in that order instead of every ZPL after the PDFs.
    var zplRun = [];
    function flushZpl() {
        if (!zplRun.length) {
            return;
        }
        sendZplBatch(zplRun);
        zplRun = [];
    }

    documents.forEach(function (doc, index) {
        try {
            if (!doc || !doc.Content) {
                return;
            }

            var contentType = (doc.ContentType || "").toLowerCase();
            if (contentType === "text/plain") {
                zplRun.push(doc.Content);
                return;
            }

            flushZpl();

            if (contentType !== "application/pdf") {
                console.warn("printShipDocuments: unrecognised ContentType", doc.ContentType, doc.DocType);
                return;
            }

            var blob = ArrayWms.convertBase64ToByteArray(doc.Content, "application/pdf");
            var prefix = (doc.DocType || "document") + "-" + Date.now() + "-" + index;
            GlobalService.printFullPageDocument(blob, "application/pdf", prefix, false);
        } catch (err) {
            console.error("printShipDocuments failed for", doc && doc.DocType, err);
            GlobalService.notification("error", shipDocumentPrintFailedMessage());
        }
    });

    flushZpl();
};
